import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="页面未找到"
        description="您访问的页面不存在。爱漫画提供海量韩国漫画在线阅读，前往首页发现精彩韩漫。"
        keywords="爱漫画,404,韩国漫画,免费韩漫"
        canonicalUrl="https://aimanga.com/404"
      />
      <Navbar />
      <main className="min-h-screen pt-20 flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <h1 className="font-heading text-8xl md:text-9xl font-black text-foreground-200 select-none">
            404
          </h1>
          <p className="mt-4 text-xl md:text-2xl font-semibold text-foreground-800">
            页面飞走了
          </p>
          <p className="mt-2 text-foreground-600">
            您访问的页面不存在，可能已经被移除了
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/category/action"
              className="whitespace-nowrap px-8 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 text-base font-medium hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer"
            >
              浏览漫画
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}